<template>
  <section>
    <template v-if="$auth.can('ver_dashboard_completo')">
      <b-row>
        <b-col md="12">
          <h2>Dashboard</h2>
        </b-col>
      </b-row>
      <b-row>
        <b-col md="12">
          <div class="bg-white p-3 mb-3">
            <b-form>
              <b-form-row>
                <b-col md="6">
                  <b-form-group label="Seleccione un rango de fechas:" label-for="dashboard-rango-fechas">
                    <b-input-group>
                      <b-input id="dashboard-rango-fechas" placeholder="Desde" v-model="dashboard.desde"></b-input>
                      <b-datepicker :initial-date="hoy" v-model="dashboard.desde" button-only show-decade-nav></b-datepicker>
                      <b-input placeholder="Hasta" v-model="dashboard.hasta"></b-input>
                      <b-datepicker :initial-date="hoy" v-model="dashboard.hasta" show-decade-nav button-only></b-datepicker>
                    </b-input-group>
                  </b-form-group>
                </b-col>
              </b-form-row>
            </b-form>

            <b-row>
              <b-col md="4">
                <div class="small-box bg-info text-light">
                  <div class="inner">
                    <h3>{{ estadisticas.ingresos }}</h3>
                    <p>Ingresos</p>
                  </div>
                </div>
              </b-col>
              <b-col md="4">
                <div class="small-box bg-warning text-light">
                  <div class="inner">
                    <h3>{{ estadisticas.ingresos_alertas }}</h3>
                    <p>Ingresos con alertas</p>
                  </div>
                </div>
              </b-col>
              <b-col md="4">
                <div class="small-box bg-danger text-light">
                  <div class="inner">
                    <h3>{{ estadisticas.rechazos }}</h3>
                    <p>Rechazos</p>
                  </div>
                </div>
              </b-col>
            </b-row>
          </div>
        </b-col>
      </b-row>
      <b-row>
        <b-col md="12">
          <div class="bg-white p-3 mb-3">
            <h5>Aforo actual</h5>
            <b-progress :max="aforo.max" height="2rem" v-if="aforo.cantidad != 0" class="mb-4">
              <b-progress-bar :value="aforo.cantidad">
                <span><strong>{{ aforo.cantidad }} / {{ aforo.max }}</strong></span>
              </b-progress-bar>
            </b-progress>

            <div v-else class="mb-2">
              <b-alert class="mt-2" show>No hay personal dentro de las instalaciones</b-alert>
            </div>
          </div>
        </b-col>
      </b-row>

      <div class="mt-4">
        <b-tabs content-class="p-3" justified>
          <!-- Tab personas totales -->
          <b-tab title="Personal en instalaciones" active>
            <b-form ref="filtros" @submit.prevent="cargarPersonal">
              <b-form-row>
                <b-col md="4">
                  <b-form-group label="Codigo:" label-for="input-filtro-codigo">
                    <b-form-input id="input-filtro-codigo" type="text" v-model="filtros.codigo"></b-form-input>
                  </b-form-group>
                </b-col>

                <b-col md="4">
                  <b-form-group label="Nombre:" label-for="input-filtro-nombre">
                    <b-form-input id="input-filtro-nombre" type="text" v-model="filtros.nombre"></b-form-input>
                  </b-form-group>
                </b-col>

                <b-col md="4">
                  <b-form-group label="Perfil:" label-for="input-filtro-perfiles">
                    <b-form-select id="input-filtro-perfiles" v-model="filtros.perfil">
                      <b-select-option :value="null">Seleccione uno</b-select-option>
                      <b-select-option v-for="perfil in perfiles" :key="perfil.key" :value="perfil.key">{{ perfil.value }}</b-select-option>
                    </b-form-select>
                  </b-form-group>
                </b-col>
              </b-form-row>
              <b-form-row>
                <b-col md="4">
                  <b-form-group label="Ordenar por:" label-for="input-orden-columna">
                    <b-input-group>
                      <b-form-select id="select-orden-columna" v-model="orden.columna">
                        <b-select-option value="hora_entrada">Hora de entrada</b-select-option>
                        <b-select-option value="hora_salida">Hora de salida</b-select-option>
                        <b-select-option value="nombre">Nombre</b-select-option>
                      </b-form-select>
                      <b-form-select id="input-orden-direccion" v-model="orden.direccion">
                        <b-select-option value="ASC">Ascendente</b-select-option>
                        <b-select-option value="DESC">Descendente</b-select-option>
                      </b-form-select>
                    </b-input-group>
                  </b-form-group>
                </b-col>
              </b-form-row>
              <b-form-row>
                <b-col>
                  <b-button variant="primary" type="submit">Filtrar</b-button>
                </b-col>

                <b-col class="d-flex flex-row-reverse">
                  <!--
              <b-button variant="primary" class="ml-2" type="submit">Exportar del dia</b-button>
              -->
                  <b-button variant="primary" type="button" @click="exportarIngreso">Exportar todos</b-button>
                </b-col>
              </b-form-row>
            </b-form>

            <b-table responsive striped hover :items="registros" :fields="camposRegistro">
              <template #cell(alertas)="row">
                <b-link href @click.prevent="verAlertas(row.item.alertas)" v-if="row.item.alertas.length > 0">Ver alertas</b-link>
                <h6 v-else>Sin Alertas</h6>
              </template>

              <template #cell(registrado_por)="row">
                <b-link href @click.prevent="verRegistrante(row.item.registrado_por)">{{ row.item.registrado_por_nombre }}</b-link>
              </template>
            </b-table>
            <b-pagination v-model="page" :total-rows="count" :per-page="limit" aria-controls="my-table" align="center"></b-pagination>
          </b-tab>

          <!-- Tab personas totales -->
          <b-tab title="Personal con entrada denegada">
            <b-form ref="filtrosDenegado" @submit.prevent="cargarDenegado">
              <b-form-row>
                <b-col>
                  <b-form-group label="Codigo:" label-for="input-filtro-codigo">
                    <b-form-input id="input-filtro-codigo" type="text" v-model="filtrosDenegado.codigo"></b-form-input>
                  </b-form-group>
                </b-col>

                <b-col>
                  <b-form-group label="Nombre:" label-for="input-filtro-nombre">
                    <b-form-input id="input-filtro-nombre" type="text" v-model="filtrosDenegado.nombre"></b-form-input>
                  </b-form-group>
                </b-col>

                <b-col>
                  <b-form-group label="Perfil:" label-for="input-filtro-perfil">
                    <b-form-select id="input-filtro-perfil" v-model="filtrosDenegado.perfil">
                      <b-select-option :value="null">Seleccione uno</b-select-option>
                      <b-select-option v-for="perfil in perfiles" :key="perfil.key" :value="perfil.key">{{ perfil.value }}</b-select-option>
                    </b-form-select>
                  </b-form-group>
                </b-col>
              </b-form-row>

              <b-form-row>
                <b-col md="4">
                  <b-form-group label="Ordenar por:" label-for="input-orden-columna">
                    <b-input-group>
                      <b-form-select id="select-orden-columna" v-model="ordenDenegado.columna">
                        <b-select-option value="hora_denegado">Hora denegado</b-select-option>
                        <b-select-option value="nombre">Nombre</b-select-option>
                      </b-form-select>
                      <b-form-select id="input-orden-direccion" v-model="ordenDenegado.direccion">
                        <b-select-option value="ASC">Ascendente</b-select-option>
                        <b-select-option value="DESC">Descendente</b-select-option>
                      </b-form-select>
                    </b-input-group>
                  </b-form-group>
                </b-col>
              </b-form-row>

              <b-form-row>
                <b-col>
                  <b-button variant="primary" type="submit">Filtrar</b-button>
                </b-col>

                <b-col class="d-flex flex-row-reverse">
                  <!--
              <b-button variant="primary" class="ml-2" type="submit">Exportar del dia</b-button>
              -->
                  <b-button variant="primary" type="button" @click="exportarDenegados">Exportar todos</b-button>
                </b-col>
              </b-form-row>
            </b-form>

            <b-table responsive striped hover :items="denegado" :fields="camposDenegado" class="mt-3">
              <template #cell(alertas)="row">
                <b-link href @click.prevent="verAlertas(row.item.alertas)" v-if="row.item.alertas.length > 0">Ver alertas</b-link>
                <h6 v-else>Sin Alertas</h6>
              </template>

              <template #cell(registrado_por)="row">
                <b-link href @click.prevent="verRegistrante(row.item.registrado_por)">Registrado por</b-link>
              </template>
            </b-table>
            <b-pagination v-model="pageDenegado" :total-rows="countDenegado" :per-page="limitDenegado" aria-controls="my-table" align="center"></b-pagination>
          </b-tab>
        </b-tabs>
      </div>
    </template>
    <template v-else>
      <b-row>
        <b-col md="12">
          <h2>Bienvenido a Actualiza #CampusSeguro</h2>
        </b-col>
        <!-- https://doretic.utb.edu.co/en-la-utb-tenemos-un-campusseguro/ -->
      </b-row>
      <b-row>
        <b-col md="12">
          <b-link href="https://doretic.utb.edu.co/en-la-utb-tenemos-un-campusseguro/" target="blank">
            <b-img alt="banner" src="images/banner_acceso.jpg" rounded="" fluid></b-img>
          </b-link>
        </b-col>
      </b-row>
    </template>

    <b-modal v-model="modalAlertas" size="lg" no-close-on-backdrop title="Alertas">
      <b-list-group>
        <b-list-group-item v-for="alerta in alertas" :key="alerta.key" :value="alerta.key">{{ alerta }}</b-list-group-item>
      </b-list-group>

      <template #modal-footer="{cancel}">
        <b-button variant="danger" @click="cancel()">Cerrar</b-button>
      </template>
    </b-modal>

    <b-modal v-model="modalRegistrante" size="lg" no-close-on-backdrop title="Registrado por">
      <h6 class="mt-2">{{ nombre }}</h6>
      <h6 class="mt-2">{{ correo }}</h6>

      <template #modal-footer="{cancel}">
        <b-button variant="danger" @click="cancel()">Cerrar</b-button>
      </template>
    </b-modal>
  </section>
</template>

<script lang="ts">
import { Vue, Component, Watch } from 'vue-property-decorator'

import axios from 'axios'
import { url } from '../../services/url_service'
import { DateTimeFormatter, LocalDate } from '@js-joda/core'

@Component
export default class Dashboard extends Vue {
  public page: number = 1
  public limit: number = 10
  public count: number = 0
  public perfiles: Array<any> = []
  public registros: Array<any> = []
  public heartBeat?: any = null

  public modalAlertas: boolean = false
  public modalRegistrante: boolean = false
  public alertas: Array<any> = []
  public alertasTotales: Array<any> = []

  public pageDenegado: number = 1
  public limitDenegado: number = 10
  public countDenegado: number = 0
  public denegado: Array<any> = []

  public dashboard: any = {
    desde: this.hoy,
    hasta: this.hoy
  }
  public filtros: any = {
    perfil: null,
  }
  public filtrosDenegado: any = {
    perfil: null,
  }
  public orden: any = {
    direccion: 'ASC',
    columna: 'hora_entrada',
  }
  public ordenDenegado: any = {
    direccion: 'ASC',
    columna: 'hora_denegado',
  }

  public aforo: any = {
    cantidad: 0,
    max: 0,
  }

  public estadisticas: any = {

  }

  public nombre: string = ''
  public correo: string = ''

  public camposDenegado: Array<any> = [
    {
      key: 'codigo',
      label: 'Código',
    },
    {
      key: 'nombre',
      label: 'Nombre',
      tdClass: 'anchoMas',
    },
    {
      key: 'perfil',
      label: 'Perfil',
    },
    {
      key: 'fecha',
      label: 'Fecha',
    },
    {
      key: 'hora_denegado',
      label: 'Hora de denegación',
    },
    {
      key: 'observaciones',
      label: 'Observaciones',
    },
    {
      key: 'alertas',
      label: 'Alertas',
    },
    {
      key: 'registrado_por',
      label: 'Registrado Por',
    },
  ]

  public camposRegistro: Array<any> = [
    {
      key: 'codigo',
      label: 'Código',
    },
    {
      key: 'nombre',
      label: 'Nombre',
    },
    {
      key: 'perfil',
      label: 'Perfil',
    },
    {
      key: 'observaciones',
      label: 'Observaciones',
    },
    {
      key: 'fecha',
      label: 'Fecha',
    },
    {
      key: 'hora_entrada',
      label: 'Hora de entrada',
    },
    {
      key: 'hora_salida',
      label: 'Hora de salida',
    },
    {
      key: 'alertas',
      label: 'Alertas',
    },
    {
      key: 'registrado_por',
      label: 'Registrado Por',
    },
  ]

  get hoy(): string {
    return LocalDate.now().format(DateTimeFormatter.ISO_LOCAL_DATE)
  }

  async verAlertas(alertas) {
    this.convertirAlerta(alertas)
    this.modalAlertas = true
  }

  async verRegistrante(id) {
    var usuario = await axios.get(url.create('/internal/usuarios/' + id))
    this.nombre = usuario.data.nombre + usuario.data.apellido
    this.correo = usuario.data.email
    this.modalRegistrante = true
  }

  async cargarDatos() {
    let response = await axios.get(url.create('/internal/parametros/aforo'))
    this.aforo.max = response.data['valor']

    response = await axios.get(url.create('/internal/alertas'))
    this.alertasTotales = response.data

    try {
      let response = await axios.get(url.create('/public/enums/perfiles'))
      this.perfiles = response.data
    } catch (error) {
      this.perfiles = []
    }

    try {
      let response = await axios.get(url.create('/internal/aforo/general'))
      this.aforo.cantidad = response.data
    } catch (error) {
      this.aforo.cantidad = 0
    }

    this.cargarEstadisticas()
    this.cargarPersonal()
    this.cargarDenegado()
  }

  convertirAlerta(alertasLocales) {
    var texto = 'Alerta desconocida'
    var alertasFinales = []
    for (let alerta of this.alertasTotales) {
      if (alertasLocales.includes(alerta.identificador)) {
        alertasFinales.push(alerta.descripcion)
      }
    }

    this.alertas = alertasFinales
  }

  async cargarEstadisticas() {
    try {
      let response = await axios.get(url.create('/internal/estadisticas'), {
        params: this.dashboard
      })
      this.estadisticas = response.data
    } catch (error) {
      this.estadisticas = {}
    }
  }

  async cargarPersonal() {
    let response = await axios.get(url.create('/internal/personal'), {
      params: {
        filtros: this.filtros,
        orden: this.orden,
        limit: this.limit,
        page: this.page,
      },
    })

    var registros = response.data.data

    // for (let registro of registros) {
    //   registro.alertas = JSON.parse(registro.alertas)
    // }

    this.registros = registros
    this.count = response.data.count
  }

  async cargarDenegado() {
    let response = await axios.get(
      url.create('/internal/personal/denegado'),
      {
        params: {
          filtros: this.filtrosDenegado,
          orden: this.ordenDenegado,
          limit: this.limitDenegado,
          page: this.pageDenegado,
        },
      }
    )

    var denegados = response.data.data

    // for (let denegado of denegados) {
    //   denegado.alertas = JSON.parse(denegado.alertas)
    // }

    this.denegado = denegados
    this.countDenegado = response.data.count
  }

  public async exportarIngreso() {
    let response = await axios.get(url.create('/internal/personal/excel'), {
      params: {
        filtros: this.filtros,
        orden: this.orden,
      },
    })
    window.location.href = response.data.enlace
  }

  public async exportarDenegados() {
    let response = await axios.get(
      url.create('/internal/personal/denegado/excel'),
      {
        params: {
          filtros: this.filtrosDenegado,
          orden: this.ordenDenegado,
        },
      }
    )
    window.location.href = response.data.enlace
  }


  // Cargar spiner mientras carga el componente
  public created() {
    this.cargarDatos()
    this.heartBeat = setInterval(this.cargarDatos, 300000)
  }

  public beforeDestroy() {
    clearInterval(this.heartBeat)
  }

  @Watch('page')
  public pageChange(val) {
    this.cargarPersonal()
  }
  @Watch('pageDenegado')
  public pageDenegadoChange(val) {
    this.cargarDenegado()
  }
  @Watch('dashboard', { deep: true })
  public dashboardChange(val) {
    this.cargarEstadisticas()
  }

}
</script>

<style>
.anchoMas {
  min-width: 300px;
}

.progress {
  background-color: #f2f2f7 !important;
  font-size: 1rem !important;
}

.small-box {
  border-radius: 0.25rem;
  box-shadow: 0 0 1px rgba(0, 0, 0, 0.125), 0 1px 3px rgba(0, 0, 0, 0.2);
  display: block;
  margin-bottom: 20px;
  position: relative;
}
.small-box h3 {
  font-size: 2.2rem;
  font-weight: 700;
  margin: 0 0 10px 0;
  padding: 0;
  white-space: nowrap;
}
.small-box p {
  font-size: 1rem;
}
.small-box > .inner {
  padding: 10px;
}
</style>